import api from './api';

export interface Tag {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}

export interface TagList {
  items: Tag[];
  total: number;
}

export const tagService = {
  async getTags(search?: string, skip = 0, limit = 10): Promise<TagList> {
    let url = `/api/v1/tags_direct?skip=${skip}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await api.get<TagList>(url);
    return response.data;
  },

  async getTag(id: number): Promise<Tag> {
    const response = await api.get<Tag>(`/api/v1/tags_direct/${id}`);
    return response.data;
  },

  async createTag(data: { name: string; description?: string }): Promise<Tag> {
    const response = await api.post<Tag>('/api/v1/tags_direct', data);
    return response.data;
  },
};

export default tagService; 